import {collection, EntityData, field, identifier, important, transientField} from "@fedeltapointofsale/data-client";
import {MetaTagDefinitionReferenceData} from "../../catalogue/meta-tag/meta-tag.data";
import {OrderTypeInfoData} from "../order-type/order-type-info.data";
import {OutletReferenceData} from "../../pos/outlet/outlet.data";
import {TypedTerminalReferenceData} from "../../pos/terminal/terminal-reference.data";

export enum OrderProcessorCapability {
    DOCKET_PRINTER = <any>"DOCKET_PRINTER",
    STOCK_ADJUSTER = <any>"STOCK_ADJUSTER",
    KVD = <any>"KVD",
    INTEGRATED_ORDER_PROCESSOR = <any>"INTEGRATED_ORDER_PROCESSOR"
}

export enum KvdDisplayType {
    QUEUE = <any>"QUEUE",
    PREP = <any>"PREP",
    EXPEDITOR = <any>"EXPEDITOR",
    DOCKET_QUEUE = <any>"DOCKET_QUEUE"
}

export enum KvdDocketTimerType {
    ORDER = <any>"ORDER",
    DISPLAY = <any>"DISPLAY"
}

export enum KvdDocketButtonType {
    BUMP = <any>"BUMP",
    TRANSITION = <any>"TRANSITION"
}

export class OrderProcessorData<T> extends EntityData<T> {
    @identifier id: number;
    @field name: string;
    @field capability: OrderProcessorCapability;

    @field groupCompositeProduct: boolean = false;
    @field groupProduct: boolean = false;
    @field shortDocket: boolean = false;
    @field showAllCourses: boolean = false;
    @field splitDockets: boolean = false;
    @field mergeDockets: boolean = true;
    @field preparationTime: number;
    @field printDefaultExtras: boolean = false;
    @field printWideProductNames: boolean = false;

    @field matchNoTags: boolean;
    @collection(MetaTagDefinitionReferenceData) tags: MetaTagDefinitionReferenceData[];
    @collection(MetaTagDefinitionReferenceData) orderTags: MetaTagDefinitionReferenceData[];
    @collection(MetaTagDefinitionReferenceData) excludedTags: MetaTagDefinitionReferenceData[];
    @collection(OrderTypeInfoData) orderTypes: OrderTypeInfoData[];
    @collection(OutletReferenceData) outlets: OutletReferenceData[];
    @collection(TypedTerminalReferenceData) terminals: TypedTerminalReferenceData[];
    @collection() webTerminalIds: number[];
    @field extrasModsOnly: boolean = false;
    @field modifiersOnly: boolean = false;
    @field onlyPrintSelectedExtras: boolean = false;
    @collection(MetaTagDefinitionReferenceData) extrasTags: MetaTagDefinitionReferenceData[];

    @field foreignKitchenTextPrinter: boolean = false;
    @field indicateDocketsAsUpdated: boolean = false;

    @important private _selectedExtrasOnly: boolean = false;

    private _orderTypeIds: number[];

    @transientField get orderTypeIds(): number[] {
        if (!this._orderTypeIds && this.orderTypes) {
            this._orderTypeIds = this.orderTypes.map((orderTypeInfo: OrderTypeInfoData) => orderTypeInfo.orderType);
        }
        return this._orderTypeIds;
    }

    set orderTypeIds(types: number[]) {
        this._orderTypeIds = types;
        if (types) {
            this.ednProxy.orderTypes = types.map((orderType: number) => {
                const entity: OrderTypeInfoData = <OrderTypeInfoData>EntityData.create(OrderTypeInfoData);
                entity.orderType = orderType;
                return entity;
            });
        } else {
            this.orderTypes = undefined;
        }
    }

    @transientField get extrasOnly(): boolean {
        return this.extrasModsOnly;
    }

    set extrasOnly(extrasOnly: boolean) {
        this.extrasModsOnly = extrasOnly;
        if (extrasOnly) {
            this.selectedExtrasOnly = false;
        }
    }

    @transientField get selectedExtrasOnly(): boolean {
        return this._selectedExtrasOnly;
    }

    set selectedExtrasOnly(selectedExtrasOnly: boolean) {
        if (this._selectedExtrasOnly !== selectedExtrasOnly) {
            this._selectedExtrasOnly = selectedExtrasOnly;
            if (selectedExtrasOnly) {
                this.extrasOnly = false;
            } else {
                this.extrasTags = [];
            }
        }
    }
}

export class KDSCapableOrderProcessorData<T> extends OrderProcessorData<T> {
    @field kvdDisplayType: KvdDisplayType;
    @field kvdSite: String;
}

